import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@glu/dropdown-react';
import LocaleContext from '../../../locale';

export const DelimitedDropdownComponent = ({ dataQa, name, options, ...props }) => {
  const locale = useContext(LocaleContext);

  return (
    <Dropdown
      name={name}
      htmlId={`${name}-${Date.now()}`}
      options={options}
      filterEnabled={false}
      dataQa={dataQa}
      defaultSelectMessage={locale['common.select']}
      placeholder={locale['common.select']}
      forcePositionY
      {...props}
    />
  );
};

DelimitedDropdownComponent.propTypes = {
  dataQa: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

DelimitedDropdownComponent.defaultProps = {
  dataQa: 'map-delimited'
};

export default DelimitedDropdownComponent;
